import {email, helpers, requiredIf} from "@vuelidate/validators";
import {CONSUMER_COMPLAINT_PATIENT_RELATIONSHIPS} from "@/utils/constants.js";

export class ConsumerComplaintAuthorizedRepModel {
    constructor(data = {}) {
        this.authRepId = data.authRepId ?? null;
        this.complaintId = data.complaintId ?? null;
        this.fullName = data.fullName ?? '';
        this.phoneNumber = data.phoneNumber ?? '';
        this.email = data.email ?? '';
        this.createdAt = data.createdAt ?? null;
        this.updatedAt = data.updatedAt ?? null;
    }

    static getValidationRules(relationshipToPatient) {
        const isOther = () => relationshipToPatient === CONSUMER_COMPLAINT_PATIENT_RELATIONSHIPS.Other;

        return {
            fullName: { required: helpers.withMessage('Your Name is required', requiredIf(isOther)) },
            phoneNumber: {required: helpers.withMessage('Your Phone Number is required', requiredIf(isOther)) },
            email: {
                email: helpers.withMessage(
                    'Consumer Complaint - Invalid email address',
                    email
                )
            },
        };
    }
}
